import React, { useState } from "react";
import { useIntl } from "gatsby-plugin-react-intl";
import { StaticImage } from "gatsby-plugin-image";

import Modal from "../Modal";
import Button from "../Button";

import * as S from "./styled";

function GreatPlaceToWork() {
  const intl = useIntl();

  const [openModal, setOpenModal] = useState(false);
  const [nameVideo] = useState("gptw");

  return (
    <>
      <S.GreatPlaceToWorkWrapper>
        <S.Col>
          <S.BoxImage>
            <S.H2>{intl.formatMessage({ id: "talents.gptw.title" })}</S.H2>
            <StaticImage
              src="../../images/talents/talentos-axur-01.png"
              alt={intl.formatMessage({ id: "talents.gptw.title" })}
              width={528}
            />
          </S.BoxImage>
        </S.Col>

        <div>
          <S.BoxText>
            <S.H3>
              {intl.formatMessage({ id: "talents.gptw.box_2.title" })}
            </S.H3>
            <S.P>{intl.formatMessage({ id: "talents.gptw.box_2.text" })}</S.P>
          </S.BoxText>

          <S.BoxText>
            <S.H3>
              {intl.formatMessage({ id: "talents.gptw.box_3.title" })}
            </S.H3>
            <S.P>{intl.formatMessage({ id: "talents.gptw.box_3.text" })}</S.P>
          </S.BoxText>

          <S.BoxText>
            <S.H3>
              {intl.formatMessage({ id: "talents.gptw.box_4.title" })}
            </S.H3>
            <S.P>{intl.formatMessage({ id: "talents.gptw.box_4.text" })}</S.P>
          </S.BoxText>

          <S.BoxText>
            <S.H3>
              {intl.formatMessage({ id: "talents.gptw.box_5.title" })}
            </S.H3>
            <S.P>{intl.formatMessage({ id: "talents.gptw.box_5.text" })}</S.P>
          </S.BoxText>

          <S.LastBoxText>
            <S.H3>
              {intl.formatMessage({ id: "talents.gptw.box_6.title" })}
            </S.H3>
            <S.P>{intl.formatMessage({ id: "talents.gptw.box_6.text" })}</S.P>
            <Button typeButton="scroll-to" goTo="#jobs">
              {intl.formatMessage({ id: "talents.btn" })}
            </Button>
          </S.LastBoxText>
        </div>
      </S.GreatPlaceToWorkWrapper>

      <Modal
        nameVideo={nameVideo}
        isOpen={openModal}
        onClickClose={() => setOpenModal(!openModal)}
        closed={() => {
          setOpenModal(false);
        }}
      />
    </>
  );
}

export default GreatPlaceToWork;
